/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_QueuedInputs */

const cs_property_ai_queued = /** @type {(inputs: Property_Ai_QueuedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Úloha zařazena`)
};

const en_property_ai_queued = /** @type {(inputs: Property_Ai_QueuedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job queued`)
};

/**
* | output |
* | --- |
* | "Job queued" |
*
* @param {Property_Ai_QueuedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_queued = /** @type {((inputs?: Property_Ai_QueuedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_QueuedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_queued(inputs)
	return cs_property_ai_queued(inputs)
});